import React, { Fragment, useState } from "react";
import BrandLogo from "components/BrandLogo";
import StripeExternalLink from "components/StripeExternalLink";
import { getStripeDestination } from "utils/stripe";
import { bindActionCreators } from "redux";
import HoverIconButton from "components/HoverIconButton";
import { connect } from "react-redux";
import { withRouter } from "next/router";
import { connect as formikConnect } from "formik";
import { getCtxAppResourceAndIDs } from "utils/mapStateToProps";
import { fetchMerchantAccountProfile } from "actions/merchantAccount";
import Callout from "components/Callout";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import Button from "components/Form/fields/Button";
import get from "lodash/get";
import { STATE_KEYS } from "utils/constants/state";
import { STRIPE_ROUTES } from "utils/constants/stripe";
import { getModelIDFromQuery } from "utils/route";
import { APPLICATION } from "utils/constants/models";
import { useAccountConnectStatusProps } from "utils/selectors";
import StripeConnectActions from "components/StripeConnectActions";
import { useIsAuthed } from "utils/selectors";
import UnauthedAccountPrompt from "components/UnauthedAccountPrompt";

const BrandField = (props) => {
  const [loading, setLoading] = useState(false);
  const { brand, formik } = props;
  const hasBrandImg = brand && brand.src;
  const isAuthed = useIsAuthed();

  const { authAction } = useAccountConnectStatusProps();

  const account = get(
    formik.values,
    `${STATE_KEYS.MANIFEST.ADMIN}.account`,
    {}
  );

  const refetchMerchantAccountProfile = () => {
    const {
      merchantAccount,
      resource,
      resourceUUID,
      actions,
      name,
      formik
    } = props;
    const { setFieldValue, setFieldTouched } = formik;
    if (merchantAccount && merchantAccount.uuid && resource && resourceUUID) {
      setLoading(true);
      actions.fetchMerchantAccountProfile(
        {
          resourceUUID,
          resource,
          uuid: merchantAccount.uuid
        },
        (_, accountProfile) => {
          setLoading(false);
          const src = get(accountProfile, "profile.businessLogo");
          const url = get(accountProfile, "profile.url");
          if (src && name) {
            const newBrand = {
              src,
              url
            };

            setFieldValue(name, newBrand);
            setFieldTouched(name, true);
          }
        }
      );
    } else {
      throw new Error(
        `Insufficient data to request for merchant account profile`
      );
    }
  };

  return isAuthed ? (
    <div className="ph3 bg-white bh--inset flex flex-column">
      <Fragment>
        <div className="flex flex-row justify-between items-center pv3">
          <label className="f6 mb2 dib fw6">Brand</label>
          {hasBrandImg && (
            <StripeExternalLink
              account={account}
              href={getStripeDestination({
                path: STRIPE_ROUTES.BRANDING,
                test: false
              })}
            />
          )}
        </div>
        {authAction ? (
          <div className="w-100 flex flex-column justify-between">
            <div className="f6 lh-copy pr2">
              {
                "Complete your Stripe onboarding to add your logo and branding to the page."
              }
            </div>
            <div className="flex flex-shrink-0 pv2">
              <div className="flex justify-start w-100 pt2 pt0-ns">
                <StripeConnectActions />
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-row justify-between items-center">
            {hasBrandImg ? (
              <Fragment>
                <BrandLogo
                  brand={brand}
                  customClasses={{ container: "ba hairline-1 br2" }}
                />
                <HoverIconButton
                  type="refresh"
                  tooltip="Refresh"
                  loading={loading}
                  onClick={refetchMerchantAccountProfile}
                />
              </Fragment>
            ) : (
              <div className="flex flex-column w-100">
                <Callout
                  copy={`To use a logo on your page, set one within your Stripe account branding settings.`}
                  customClasses={{
                    container:
                      "flex ph2 ba br2 items-center b--black-10 pv2 w-100 justify-between flex-shrink-0"
                  }}
                >
                  <HoverIconButton
                    type="refresh"
                    tooltip="Refresh"
                    loading={loading}
                    onClick={refetchMerchantAccountProfile}
                  />
                </Callout>
                <div className="pt3">
                  <Button
                    theme="slim"
                    classes={{
                      contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
                    }}
                    tag="a"
                    target="_blank"
                    href={getStripeDestination({
                      path: STRIPE_ROUTES.BRANDING,
                      test: false
                    })}
                    copy="Add logo"
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </Fragment>
    </div>
  ) : (
    <UnauthedAccountPrompt
      header="Use your own logo"
      subheader="Sign up to use your own logo, assets and products in your checkout pages."
      customClasses={{
        actionsWrapper: "pt3",
        header: "f5 fw6",
        subheader: "f6 lh-copy",
        container:
          "w-100 flex flex-column justify-between pa3 items-start bg-white bh--inset bb hairline-1"
      }}
    />
  );
};

const mapStateToProps = (state, { router }) => {
  const applicationUUID = getModelIDFromQuery(APPLICATION, router.query);
  const merchantAccount = state.getIn(["merchantAccount", "data"]).toJS()[0];

  return {
    ...getCtxAppResourceAndIDs(state, applicationUUID),
    merchantAccount
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchMerchantAccountProfile
    },
    dispatch
  )
});

export default formikConnect(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandField))
);
